module.exports = __webpack_public_path__ + "static/media/footer_7.f87f34ea.png";